module.exports = __webpack_public_path__ + "img/shutterstock_323846798@2x.496b084d.png";